// When retries left <= REST_RETRIES_QUICK_THRESHOLD then REST_RETRIES_QUICK_DELAY is used instead of REST_RETRIES_DELAY
export const REST_RETRIES = 7;
export const REST_RETRIES_QUICK_DELAY = 0.25;
